export interface ExchangeFile {
  id: string;
  sponsorId: string;
  date: string;
  dateTime: string;
  sftpPath: string;
  direction: FileExchangeDirection;
  status: ExchangeFileStatus;
  failCause: string;
}

export enum ExchangeFileStatus {
  PULLED = 'PULLED',
  SENT = 'SENT',
  FAILED = 'FAILED',
}

type TitleObject<T extends string> = Readonly<{
  [key in T]: string;
}>;

export const FILE_EXCHANGE_TYPE_TITLES: TitleObject<ExchangeFileStatus> = Object.freeze({
  PULLED: 'Pulled',
  SENT: 'Sent',
  FAILED: 'Failed',
});

export enum FileExchangeDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

/**
 * Exchange File Service for dashboards on files-tracking page
 * */
export enum FileExchangeService {
  PDF = 'PDF',
  CSV = 'CSV',
  EDI = 'EDI',
}
